import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EnvironmentVariables } from "models/environment";
import env from "modules/env/env";
import "./index.css";
import Layout from "./pages/layout";
import MainPage from "./pages/mainpage";
import { Delete } from "./pages/delete";
import ErrorPage from "./pages/errorPage";
import i18n from "./i18n";
import CountryRoute from "route/countryRoute";
import ReasonDeletePage from "pages/delete/reasonDelete";
import InfoPage from "pages/delete/info";
import { Success } from "components/success";
import { redirectToLogin } from "./util";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<MainPage />} />
          <Route path="/delete" element={<Delete />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/success" element={<Success />}/>
          <Route
            path="/info-screen"
            element={
              <CountryRoute countryCode={["id", "en"]}>
                <InfoPage handleClick={() => {
                  redirectToLogin()
                }}/>
              </CountryRoute>
            }
          ></Route>
          <Route
            path="/reason-delete"
            element={
              <CountryRoute countryCode={["id", "en"]}>
                <ReasonDeletePage />
              </CountryRoute>
            }
          ></Route>
          <Route path="*" element={<MainPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export const language = env(EnvironmentVariables.countryCode);
i18n.changeLanguage(language);
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
